<form-control [config]="inputConfig" [control]="inputControl"> </form-control>

<form-control
  [group]="formGroup"
  [config]="checkboxConfig"
  [control]="formGroup.get(naProp)"
>
</form-control>
